<template>
  <div class="policy-page" dir="rtl">
    <!-- Scroll Progress Bar -->
    <div class="scroll-progress" :style="{ width: scrollProgress + '%' }"></div>

    <!-- Animated Background -->
    <div class="background-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>

    <!-- Header -->
    <header>
      <div class="logo-container">
        <img
          src="@/assets/media/images/logo/logo.png"
          alt="Yalla Qata Logo"
          class="logo"
        />
      </div>
      <h1>سياسة الخصوصية</h1>
      <p>
        خصوصيتك مهمة بالنسبة لنا. تعرف على كيفية جمع معلوماتك واستخدامها
        وحمايتها.
      </p>
    </header>

    <!-- Main Content -->
    <div class="container">
      <div class="policy-card">
        <!-- Introduction -->
        <div class="section">
          <span class="info-badge">آخر تحديث: يناير 2026</span>
          <h2>المقدمة</h2>
          <p>
            مرحباً بك في يلا قطعة. نحن ملتزمون بحماية معلوماتك الشخصية وحقك في
            الخصوصية. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها
            والكشف عنها وحمايتها عند زيارة موقعنا الإلكتروني أو استخدام خدماتنا.
          </p>
          <div class="highlight-box">
            <p>
              <strong>مهم:</strong> باستخدام خدماتنا، فإنك توافق على جمع
              واستخدام المعلومات وفقًا لهذه السياسة. إذا كنت لا توافق على
              سياساتنا وممارساتنا، يرجى عدم استخدام خدماتنا.
            </p>
          </div>
        </div>

        <!-- Information We Collect -->
        <div class="section">
          <h2>المعلومات التي نجمعها</h2>
          <p>نجمع عدة أنواع من المعلومات لتقديم خدماتنا وتحسينها لك:</p>

          <h3>المعلومات الشخصية</h3>
          <ul>
            <li>
              الاسم ومعلومات الاتصال (عنوان البريد الإلكتروني، رقم الهاتف)
            </li>
            <li>عناوين الشحن والفواتير</li>
            <li>
              معلومات الدفع (تتم معالجتها بشكل آمن من خلال مزودي خدمات خارجيين)
            </li>
            <li>بيانات اعتماد الحساب</li>
            <li>سجل المشتريات والتفضيلات</li>
          </ul>

          <h3>بيانات الاستخدام</h3>
          <ul>
            <li>عنوان IP ونوع المتصفح</li>
            <li>الصفحات التي تمت زيارتها والوقت المستغرق على موقعنا</li>
            <li>معلومات الجهاز ونظام التشغيل</li>
            <li>عناوين مواقع الويب المُحيلة</li>
            <li>ملفات تعريف الارتباط وتقنيات التتبع المماثلة</li>
          </ul>
        </div>

        <!-- How We Use Your Information -->
        <div class="section">
          <h2>كيفية استخدام معلوماتك</h2>
          <p>نستخدم المعلومات التي نجمعها بطرق مختلفة، بما في ذلك:</p>
          <ul>
            <li>معالجة وتنفيذ طلباتك ومعاملاتك</li>
            <li>تقديم دعم العملاء والرد على استفساراتك</li>
            <li>إرسال تحديثات حول طلباتك وحسابك</li>
            <li>تحسين موقعنا وخدماتنا بناءً على ملاحظاتك</li>
            <li>تخصيص تجربتك وتقديم محتوى ذي صلة</li>
            <li>اكتشاف ومنع ومعالجة المشكلات التقنية أو الأنشطة الاحتيالية</li>
            <li>الامتثال للالتزامات القانونية وإنفاذ شروطنا</li>
            <li>إرسال اتصالات ترويجية (بموافقتك)</li>
          </ul>
        </div>

        <!-- Data Sharing and Disclosure -->
        <div class="section">
          <h2>مشاركة البيانات والإفصاح عنها</h2>
          <p>نحن لا نبيع معلوماتك الشخصية. قد نشارك معلوماتك مع:</p>

          <div class="highlight-box">
            <p>
              <strong>مزودو الخدمات:</strong> نعمل مع شركات خارجية لتسهيل
              خدماتنا، مثل معالجات الدفع وشركات الشحن ومزودي خدمات البريد
              الإلكتروني.
            </p>
          </div>

          <ul>
            <li>شركاء الأعمال الذين يساعدون في تقديم خدماتنا</li>
            <li>مزودي التحليلات لمساعدتنا على فهم كيفية استخدام خدماتنا</li>
            <li>السلطات القانونية عند الطلب بموجب القانون أو لحماية حقوقنا</li>
            <li>المشترين المحتملين في حالة نقل الأعمال أو الاندماج</li>
          </ul>
        </div>

        <!-- Data Security -->
        <div class="section">
          <h2>أمن البيانات</h2>
          <p>
            نطبق تدابير أمنية تقنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من
            الوصول غير المصرح به أو التعديل أو الكشف أو التدمير. تشمل هذه
            التدابير:
          </p>
          <ul>
            <li>تشفير البيانات الحساسة أثناء النقل (SSL/TLS)</li>
            <li>تقييمات وتحديثات أمنية منتظمة</li>
            <li>ضوابط الوصول وآليات المصادقة</li>
            <li>إجراءات تخزين البيانات والنسخ الاحتياطي الآمنة</li>
            <li>تدريب الموظفين على ممارسات حماية البيانات</li>
          </ul>
          <div class="highlight-box">
            <p>
              ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100%. بينما
              نسعى لحماية معلوماتك، لا يمكننا ضمان الأمان المطلق.
            </p>
          </div>
        </div>

        <!-- Your Rights -->
        <div class="section">
          <h2>حقوق الخصوصية الخاصة بك</h2>
          <p>
            اعتمادًا على موقعك، قد يكون لديك حقوق معينة فيما يتعلق بمعلوماتك
            الشخصية:
          </p>
          <ul>
            <li>
              <strong>الوصول:</strong> طلب الوصول إلى المعلومات الشخصية التي
              نحتفظ بها عنك
            </li>
            <li>
              <strong>التصحيح:</strong> طلب تصحيح المعلومات غير الدقيقة أو غير
              الكاملة
            </li>
            <li><strong>الحذف:</strong> طلب حذف معلوماتك الشخصية</li>
            <li><strong>الاعتراض:</strong> الاعتراض على معالجتنا لمعلوماتك</li>
            <li>
              <strong>قابلية النقل:</strong> طلب نقل بياناتك إلى خدمة أخرى
            </li>
            <li>
              <strong>الانسحاب:</strong> سحب الموافقة على الاتصالات التسويقية في
              أي وقت
            </li>
          </ul>
        </div>

        <!-- Cookies and Tracking -->
        <div class="section">
          <h2>ملفات تعريف الارتباط وتقنيات التتبع</h2>
          <p>
            نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتتبع النشاط على
            موقعنا وتخزين معلومات معينة. يمكنك توجيه متصفحك لرفض جميع ملفات
            تعريف الارتباط أو الإشارة عند إرسال ملف تعريف ارتباط.
          </p>
          <ul>
            <li>
              <strong>ملفات تعريف الارتباط الأساسية:</strong> ضرورية لعمل الموقع
              بشكل صحيح
            </li>
            <li>
              <strong>ملفات تعريف الارتباط التحليلية:</strong> تساعدنا على فهم
              كيفية استخدام الزوار لموقعنا
            </li>
            <li>
              <strong>ملفات تعريف الارتباط التفضيلية:</strong> تتذكر إعداداتك
              وتفضيلاتك
            </li>
            <li>
              <strong>ملفات تعريف الارتباط التسويقية:</strong> تتبع تصفحك لتقديم
              إعلانات ذات صلة
            </li>
          </ul>
        </div>

        <!-- Children's Privacy -->
        <div class="section">
          <h2>خصوصية الأطفال</h2>
          <p>
            خدماتنا غير مخصصة للأفراد الذين تقل أعمارهم عن 13 عامًا. نحن لا نجمع
            عن قصد معلومات شخصية من الأطفال دون سن 13 عامًا. إذا علمت أن طفلاً
            قدم لنا معلومات شخصية، يرجى الاتصال بنا على الفور.
          </p>
        </div>

        <!-- Changes to This Policy -->
        <div class="section">
          <h2>التغييرات على سياسة الخصوصية هذه</h2>
          <p>
            قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر. سنخطرك بأي
            تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث
            تاريخ "آخر تحديث". ننصحك بمراجعة سياسة الخصوصية هذه بشكل دوري لمعرفة
            أي تغييرات.
          </p>
        </div>

        <!-- Contact Us -->
        <div class="contact-info">
          <h3>اتصل بنا</h3>
          <p>
            إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارسات البيانات
            الخاصة بنا، يرجى الاتصال بنا:
          </p>
          <p>
            <strong>البريد الإلكتروني:</strong>
            <a href="mailto:privacy@yallaqata.com">privacy@yallaqata.com</a
            ><br />
            <strong>الهاتف:</strong> <a href="tel:+1234567890">+123 456 7890</a>
          </p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer>
      <p>&copy; 2026 يلا قطعة. جميع الحقوق محفوظة.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "PolicyPage",
  data() {
    return {
      scrollProgress: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollProgress);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateScrollProgress);
  },
  methods: {
    updateScrollProgress() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      this.scrollProgress = (scrollTop / scrollHeight) * 100;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.policy-page {
  font-family: "Cairo", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%);
  color: #1a1a1a;
  line-height: 1.8;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Animated Background */
.background-shapes {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.shape {
  position: absolute;
  opacity: 0.05;
  animation: float 20s infinite ease-in-out;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: #7d35f3;
  border-radius: 50%;
  top: 10%;
  right: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: #e7cdac;
  border-radius: 50%;
  top: 60%;
  left: 15%;
  animation-delay: 5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: #61bca1;
  border-radius: 50%;
  bottom: 20%;
  right: 20%;
  animation-delay: 10s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, -30px) scale(1.1);
  }
  50% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  75% {
    transform: translate(20px, 30px) scale(1.05);
  }
}

/* Header */
header {
  position: relative;
  z-index: 10;
  background: linear-gradient(135deg, #7d35f3 0%, #6528d4 100%);
  color: white;
  padding: 2rem 1.5rem 4rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(125, 53, 243, 0.3);
}

.logo-container {
  margin-bottom: 1.5rem;
  animation: fadeInDown 0.6s ease-out;
}

.logo {
  max-width: 120px;
  height: auto;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

header h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  animation: fadeInDown 0.8s ease-out 0.2s both;
}

header p {
  font-size: 1.125rem;
  opacity: 0.95;
  max-width: 600px;
  margin: 0 auto;
  font-weight: 300;
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

/* Main Container */
.container {
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
}

/* Policy Card */
.policy-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease-out 0.6s both;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.policy-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 50px rgba(125, 53, 243, 0.15);
}

/* Section Styling */
.section {
  margin-bottom: 3rem;
}

.section:last-child {
  margin-bottom: 0;
}

.section h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #7d35f3;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 3px solid #7d35f3;
  position: relative;
  display: inline-block;
}

.section h2::after {
  content: "";
  position: absolute;
  bottom: -3px;
  right: 0;
  width: 50%;
  height: 3px;
  background: linear-gradient(90deg, #e7cdac, transparent);
}

.section h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.section p {
  color: #666666;
  margin-bottom: 1rem;
  text-align: justify;
}

.section ul {
  list-style: none;
  padding-right: 0;
  margin: 1.5rem 0;
}

.section ul li {
  color: #666666;
  padding-right: 1.5rem;
  margin-bottom: 1rem;
  position: relative;
}

.section ul li::before {
  content: "";
  position: absolute;
  right: 0;
  top: 10px;
  width: 6px;
  height: 6px;
  background: #7d35f3;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(125, 53, 243, 0.5);
}

/* Highlight Box */
.highlight-box {
  background: linear-gradient(
    135deg,
    rgba(125, 53, 243, 0.05) 0%,
    rgba(231, 205, 172, 0.05) 100%
  );
  border-right: 4px solid #7d35f3;
  padding: 1.5rem;
  border-radius: 8px;
  margin: 1.5rem 0;
  transition: all 0.3s ease;
}

.highlight-box:hover {
  background: linear-gradient(
    135deg,
    rgba(125, 53, 243, 0.08) 0%,
    rgba(231, 205, 172, 0.08) 100%
  );
  transform: translateX(-4px);
}

.highlight-box p {
  margin-bottom: 0;
}

/* Info Badge */
.info-badge {
  display: inline-block;
  background: linear-gradient(135deg, #61bca1 0%, #4da88d 100%);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(97, 188, 161, 0.3);
}

/* Contact Section */
.contact-info {
  background: linear-gradient(135deg, #7d35f3 0%, #6528d4 100%);
  color: white;
  padding: 2rem;
  border-radius: 12px;
  text-align: center;
  margin-top: 3rem;
  box-shadow: 0 8px 25px rgba(125, 53, 243, 0.3);
}

.contact-info h3 {
  color: white;
  margin-bottom: 1rem;
}

.contact-info a {
  color: #e7cdac;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-block;
}

.contact-info a:hover {
  color: white;
  transform: scale(1.05);
}

/* Footer */
footer {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  margin-top: 3rem;
}

footer p {
  color: #666666;
  font-size: 0.875rem;
}

/* Animations */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .logo {
    max-width: 100px;
  }

  header h1 {
    font-size: 2rem;
  }

  header p {
    font-size: 1rem;
  }

  .policy-card {
    padding: 1.5rem;
  }

  .section h2 {
    font-size: 1.5rem;
  }

  .container {
    padding: 1.5rem 1rem;
  }
}

/* Scroll Progress Bar */
.scroll-progress {
  position: fixed;
  top: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #7d35f3, #e7cdac);
  z-index: 1000;
  transition: width 0.1s ease;
}
</style>

